// extracted by mini-css-extract-plugin
module.exports = {"root":"DlpListingsPopular_root__x8dNt"};